import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SuccessCountry extends DexResourceModel {

    @Field(String)
    public countryName: string = "";
    @Field(String)
    public countryAbbreviation: string = "";

    @Field(Boolean)
    public isEFileAvailable: boolean = false;


    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
